import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'common/lazy';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import HomepageImage from 'public/screens/Home/Components/Image';
import HomepageAsset from '../Asset';
import './info-modal.less';
import Link from '../Link';

export default function InfoModal({ component, trigger, onOpen }) {
  const classNames = useClassName('CLPInfoModal');
  const [isOpen, setIsOpen] = useState(false);
  const {
    ctaText,
    title,
    description,
    logo,
    specs,
    asset,
    link,
    additionalInfo,
  } = component?.fields || {};

  const handleOpen = (...args) => {
    setIsOpen(true);
    onOpen?.(...args);
  };

  return (
    <Modal
      onClose={() => setIsOpen(false)}
      onOpen={handleOpen}
      open={isOpen}
      trigger={
        trigger || (
          <button type="button" className={classNames('trigger-button')}>
            {ctaText}
          </button>
        )
      }
      className={classNames('modal')}>
      <div className={classNames('container')}>
        <button
          type="button"
          className={classNames('close-button')}
          onClick={() => setIsOpen(false)}>
          x
        </button>
        <div className={classNames('header')}>
          <div className={classNames('title-container')}>
            <p className={classNames('title')}>{title}</p>
            {description && (
              <div className={classNames('description')}>
                <ContentfulRichText field={{ 'en-US': description }} />
              </div>
            )}
          </div>
          {logo && (
            <div className={classNames('logo-containter')}>
              <HomepageImage field={logo} />
            </div>
          )}
        </div>
        {specs?.length && (
          <div className={classNames('specs')}>
            {specs.map((spec) => (
              <div key={spec.fields.key} className={classNames('spec')}>
                <p className={classNames('spec-value')}>{spec.fields.value}</p>
                <p className={classNames('spec-key')}>{spec.fields.key}</p>
              </div>
            ))}
          </div>
        )}

        {asset && (
          <div className={classNames('asset-container')}>
            <div className={classNames('asset')}>
              <HomepageAsset
                asset={asset}
                settings={component.fields.settings}
              />
            </div>
            {link && <Link component={link} />}
          </div>
        )}

        {additionalInfo && (
          <div className={classNames('secondary-section')}>
            <div className={classNames('subtitle-container')}>
              <p className={classNames('subtitle')}>
                {additionalInfo.fields.title}
              </p>

              {additionalInfo?.fields?.description && (
                <div className={classNames('secondary-description')}>
                  <ContentfulRichText
                    field={{ 'en-US': additionalInfo.fields.description }}
                  />
                </div>
              )}

              {additionalInfo?.fields?.tags?.length && (
                <div className={classNames('tags')}>
                  {additionalInfo.fields.tags.map((tag) => (
                    <div key={tag} className={classNames('tag')}>
                      {tag}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {additionalInfo?.fields?.asset && (
              <HomepageAsset
                asset={additionalInfo.fields.asset}
                settings={additionalInfo.fields.settings}
              />
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}

InfoModal.propTypes = {
  component: PropTypes.object.isRequired,
  onOpen: PropTypes.func,
  trigger: PropTypes.node,
};

InfoModal.defaultProps = {
  onOpen: null,
  trigger: null,
};
